// Data for Expert Property Maintenance - Property Maintenance for Landlords, Letting Agents & Homeowners

// ⚠️ EMAIL ADDRESS - CENTRALIZED CONSTANT
// Updated: info@expert-propertymaintenance.co.uk (official EPM domain)
export const COMPANY_EMAIL = "info@expert-propertymaintenance.co.uk";

export const companyInfo = {
  name: "Expert Property Maintenance",
  tagline: "Property Maintenance for Landlords, Letting Agents & Homeowners",
  phone: "07300 405045",
  email: COMPANY_EMAIL,
  serviceArea: "Greater Manchester & Cheshire",
  insurance: {
    publicLiability: "£5 million public liability insurance",
    employersLiability: "£15 million employers' liability insurance"
  },
  guarantee: "12-month workmanship guarantee",
  websites: [
    { name: "Expert Handyman", url: "https://expert-handyman.co.uk" },
    { name: "Expert Carpenter", url: "https://expert-carpenter.co.uk" },
    { name: "Expert Painter", url: "https://expert-painter.co.uk" },
    { name: "Expert Plasterer", url: "https://expert-plasterer.co.uk" }
  ]
};

// Specialist Expert Brands with their ACTUAL logos
export const specialistBrands = [
  {
    id: 1,
    name: "Expert Handyman",
    tagline: "General Repairs & Installations",
    description: "General repairs, installations and maintenance for all types of property.",
    logo: "https://customer-assets.emergentagent.com/job_81cb62f6-f449-40b4-be2e-6ad64253292f/artifacts/2zhsy1xr_expert-trades%20direct%20logo.png",
    website: "https://expert-handyman.co.uk"
  },
  {
    id: 2,
    name: "Expert Carpenter",
    tagline: "Carpentry, Joinery & Woodwork",
    description: "Carpentry, joinery, doors, skirting, storage and all woodwork repairs.",
    logo: "https://customer-assets.emergentagent.com/job_81cb62f6-f449-40b4-be2e-6ad64253292f/artifacts/lkjd4i62_carpenter%20logo.png",
    website: "https://expert-carpenter.co.uk"
  },
  {
    id: 3,
    name: "Expert Painter",
    tagline: "Painting & Decorating",
    description: "Interior and exterior painting and decorating to the highest standard.",
    logo: "https://customer-assets.emergentagent.com/job_81cb62f6-f449-40b4-be2e-6ad64253292f/artifacts/uq0yx45y_expert-painter%20logo%20new.png",
    website: "https://expert-painter.co.uk"
  },
  {
    id: 4,
    name: "Expert Plasterer",
    tagline: "Plastering & Rendering",
    description: "Plaster repairs, skimming, rendering and associated works.",
    logo: "https://customer-assets.emergentagent.com/job_81cb62f6-f449-40b4-be2e-6ad64253292f/artifacts/ha6hrqty_plastering.png",
    website: "https://expert-plasterer.co.uk"
  }
];

// Core Property Maintenance Services
export const coreServices = [
  {
    id: 1,
    title: "Reactive Maintenance",
    description: "Prompt attention to urgent repairs and reported faults, keeping homes and rental properties safe and in good order.",
    icon: "Wrench"
  },
  {
    id: 2,
    title: "Planned Maintenance",
    description: "Scheduled upkeep that helps protect property condition and reduce unexpected repair costs over time.",
    icon: "Calendar"
  },
  {
    id: 3,
    title: "End of Tenancy Repairs",
    description: "Getting a property ready for the next tenant quickly to help reduce void periods between lets.",
    icon: "Key"
  },
  {
    id: 4,
    title: "Void Property Works",
    description: "Full preparation of empty properties — repairs, cleaning and redecoration — ready to relet or sell.",
    icon: "Home"
  },
  {
    id: 5,
    title: "Property Refurbishment",
    description: "Coordinated multi-trade improvements to modernise a home or rental property, whether for living in, letting or sale.",
    icon: "Building"
  },
  {
    id: 6,
    title: "Painting & Decorating",
    description: "Refreshing interiors and exteriors so homes and rental properties always look their best.",
    icon: "Paintbrush"
  },
  {
    id: 7,
    title: "Carpentry & Joinery",
    description: "Doors, skirting, storage and repairs completed to a durable, tidy finish.",
    icon: "Hammer"
  },
  {
    id: 8,
    title: "Handyman Repairs",
    description: "Several smaller jobs handled in a single visit through one contractor, reducing coordination for you.",
    icon: "Tool"
  },
  {
    id: 9,
    title: "Plastering",
    description: "Making good walls and ceilings ready for redecoration after repairs or damage.",
    icon: "Layers"
  },
  {
    id: 10,
    title: "Plumbing",
    description: "Leaks, taps, toilets and radiators resolved, including making good after the work.",
    icon: "Droplets"
  },
  {
    id: 11,
    title: "Electrical",
    description: "Sockets, switches and lighting attended to, with making good after electrical work.",
    icon: "Zap"
  }
];

// Landlord/Agent specific services
export const landlordServices = [
  {
    title: "Individual Repair Jobs",
    description: "One-off repairs and maintenance tasks across your portfolio."
  },
  {
    title: "Ongoing Maintenance",
    description: "Regular maintenance support for landlords and agents managing multiple properties."
  },
  {
    title: "Tenant-Reported Problems",
    description: "Prompt response to issues reported by tenants, keeping you informed throughout."
  },
  {
    title: "End of Tenancy Repairs",
    description: "Quick turnaround repairs between tenancies to minimise void periods."
  },
  {
    title: "Property Inspections",
    description: "Inspections followed by detailed reports and remedial works if required."
  },
  {
    title: "Void Turnaround Works",
    description: "Complete void property preparation including repairs, decorating and cleaning."
  },
  {
    title: "Decorating",
    description: "Professional painting and decorating to refresh tired properties."
  },
  {
    title: "Carpentry",
    description: "Door repairs, skirting, architraves and general woodwork."
  },
  {
    title: "Minor Plumbing & Electrical",
    description: "Small plumbing and electrical repairs without needing separate contractors."
  },
  {
    title: "Plaster Repairs",
    description: "Patch repairs and wall preparation before redecoration."
  },
  {
    title: "Complete Refurbishments",
    description: "Full rental property refurbishments to maximise rental potential."
  }
];

// How It Works steps
export const howItWorks = [
  {
    step: 1,
    title: "Tell Us What Needs Doing",
    description: "Send details, photographs and property information via our form or WhatsApp."
  },
  {
    step: 2,
    title: "We Assess the Work",
    description: "We arrange access or obtain any further information needed to quote."
  },
  {
    step: 3,
    title: "Work Is Carried Out",
    description: "The appropriate tradesperson completes the work to a high standard."
  },
  {
    step: 4,
    title: "Job Completion",
    description: "Work is checked and you are updated with photos and confirmation."
  }
];

// Why Choose Us - genuine differentiators for both audiences
export const whyChooseUs = [
  {
    title: "One Point of Contact",
    description: "Coordinate multiple trades through one maintenance company, rather than managing each contractor yourself."
  },
  {
    title: "Multi-Trade Capability",
    description: "Repairs, decorating, joinery, plastering and refurbishment delivered through one service."
  },
  {
    title: "Property Industry Understanding",
    description: "First-hand understanding of the requirements of letting agents, landlords and property professionals."
  },
  {
    title: "Clear Communication",
    description: "Straightforward communication and a clear point of contact from enquiry through to completion."
  },
  {
    title: "Properly Insured",
    description: "£5m Public Liability and £15m Employers' Liability insurance in place."
  },
  {
    title: "12-Month Workmanship Guarantee",
    description: "All completed work is backed by a genuine 12-month workmanship guarantee."
  }
];

// Homeowner-specific services
export const homeownerServices = [
  {
    title: "General Household Repairs",
    description: "Fixing, adjusting and repairing things around your home."
  },
  {
    title: "Handyman Jobs",
    description: "Shelving, curtain rails, TV mounting, flat-pack assembly and odd jobs."
  },
  {
    title: "Painting & Decorating",
    description: "Interior and exterior painting, feature walls and property refreshes."
  },
  {
    title: "Carpentry & Joinery",
    description: "Doors, skirting, architraves, built-in storage and woodwork repairs."
  },
  {
    title: "Plaster Repairs",
    description: "Patching, skimming, making good and wall preparation."
  },
  {
    title: "Boxing-In & Finishing",
    description: "Boxing-in pipework, tidying up and finishing touches."
  },
  {
    title: "Minor Plumbing",
    description: "Dripping taps, toilet repairs, radiator issues and small plumbing fixes."
  },
  {
    title: "Minor Electrical",
    description: "Sockets, switches, light fittings and minor electrical work."
  },
  {
    title: "Sealant & Grouting",
    description: "Kitchen and bathroom resealing, grout repairs and refresh."
  },
  {
    title: "Property Improvements",
    description: "Small improvements and upgrades to enhance your home."
  },
  {
    title: "Refurbishment Work",
    description: "Larger projects combining multiple trades under one contractor."
  }
];

// Service areas - accurate coverage
export const serviceAreas = [
  "Manchester",
  "Stockport",
  "Cheadle",
  "Didsbury",
  "Sale",
  "Altrincham",
  "Salford",
  "Trafford",
  "Oldham",
  "Warrington",
  "Wilmslow",
  "Macclesfield"
];

// Testimonials - genuine only (removed placeholder Sarah M)
export const testimonials = [
  {
    id: 1,
    name: "Bilal Akhtar",
    role: "Property Manager",
    company: "Inspire Capital PROPCO",
    quote: "We've been using Expert Property Maintenance for a range of maintenance and repair work across our investment and rental properties. Max and his team have proven to be the most reliable and professional by far — responsive, tidy, and always delivering excellent results.",
    rating: 5
  },
  {
    id: 2,
    name: "Patrick",
    role: "Homeowner",
    company: "Stockport",
    quote: "Max was brilliant. He was able to solve a number of problems with the provided materials and completed the job to an impeccable standard. Would recommend highly!",
    rating: 5
  }
];

// Customer types for form
export const customerTypes = [
  { value: "homeowner", label: "Homeowner" },
  { value: "landlord", label: "Landlord" },
  { value: "letting_agent", label: "Letting Agent" },
  { value: "property_manager", label: "Property Manager" },
  { value: "other", label: "Other" }
];

// FAQs
export const faqs = [
  {
    question: "Do you work with landlords and letting agents?",
    answer: "Yes. We work with landlords, letting agents and property managers across Greater Manchester, providing reliable maintenance and refurbishment services including end of tenancy repairs, void works and ongoing property maintenance."
  },
  {
    question: "How do I get a quote?",
    answer: "Fill in the form on this page, give us a call on 07300 405045, or send a WhatsApp message with details and photos. We'll get back to you with a quote, usually within 24 hours."
  },
  {
    question: "What areas do you cover?",
    answer: "We cover Greater Manchester and Cheshire, including Manchester, Stockport, Cheadle, Didsbury, Wilmslow, Altrincham, Sale and surrounding areas."
  },
  {
    question: "Are you fully insured?",
    answer: "Yes. We carry £5 million public liability insurance and £15 million employers' liability insurance. All work is also covered by our 12-month workmanship guarantee."
  },
  {
    question: "Can you handle multiple trades on one job?",
    answer: "Yes. Expert Property Maintenance brings together carpentry, painting, plastering, plumbing, electrical and general repairs under one service. You don't need to coordinate multiple contractors."
  }
];
